import {
  AfterViewInit,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  ControlContainer,
  UntypedFormGroup,
  FormGroupName,
} from '@angular/forms';
import { PrFormAbstract } from '../pr-form.abstract';
import * as _ from 'lodash';

@Component({
    selector: 'pr-form-list-item',
    templateUrl: './pr-form-list-item.component.html',
    styleUrls: ['./pr-form-list-item.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PrFormListItemComponent implements OnInit, AfterViewInit {
  @Input() derrors: boolean = false;

  @Input() formGroupName: FormGroupName;

  @Input() formGroup: UntypedFormGroup;

  @Input() index: number;

  @Input() itemName: string = 'cet item';

  @Input() context;

  @Input() headerClass: string;

  @Input() clazz: string;

  @Input() buttonStyle: 'icon' | 'label' = 'icon';

  @Input() buttonClass: string;

  @Input() buttonIconVbWidth: string;

  @Input() buttonIconVbHeight: string;

  @Input() showReturnChevron: boolean = true;

  @ViewChild('item', { static: true }) item: ElementRef;

  @ContentChild(PrFormAbstract, { static: true }) form: PrFormAbstract;

  @Output() onDelete: EventEmitter<number> = new EventEmitter();

  @Output() onValidate: EventEmitter<number> = new EventEmitter();

  _default = {};

  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    if (!this.form) this.form = this.context;
  }

  open() {
    this._default = _.clone(this.form.form.value);
    this.item.nativeElement.classList.add('open');
  }

  close() {
    this.item.nativeElement.classList.remove('open');
  }

  cancel() {
    if (this.form) this.form.form.setValue(this._default);
    else this.form.reset();
    this.close();
  }

  validate() {
    if (
      this.form.form.status === 'VALID' ||
      this.formGroup.status === 'VALID'
    ) {
      this.close();
      this.onValidate.emit();
    } else {
      this.form.displayErrors();
    }
  }

  delete() {
    this.close();
    this.onDelete.emit(this.index);
  }
}
